module.exports = __webpack_public_path__ + "static/media/survey.b48362b4.svg";